import { render, staticRenderFns } from "./NewCourseInfoStep.vue?vue&type=template&id=655f7faa&"
import script from "./NewCourseInfoStep.vue?vue&type=script&lang=ts&"
export * from "./NewCourseInfoStep.vue?vue&type=script&lang=ts&"
import style0 from "./NewCourseInfoStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})
